import { isNumber } from "lodash";

export function inAgeRangeLabel({ minimumAge, maximumAge } = {}) {
  if (isNumber(minimumAge) && minimumAge !== 0 && isNumber(maximumAge)) {
    return `Between ${minimumAge} and ${maximumAge}`;
  }

  if (isNumber(minimumAge) && minimumAge !== 0) {
    return `${minimumAge} or older`;
  }

  if (isNumber(maximumAge)) {
    return `${maximumAge} or younger`;
  }
}

export function outAgeRangeLabel({ minimumAge, maximumAge } = {}) {
  if (isNumber(minimumAge) && minimumAge !== 0 && isNumber(maximumAge)) {
    return `Under ${minimumAge} or over ${maximumAge}`;
  }

  if (isNumber(minimumAge) && minimumAge !== 0) {
    return `${minimumAge - 1} or younger`;
  }

  if (isNumber(maximumAge)) {
    return `${maximumAge + 1} or older`;
  }
}
